export const authenticationService = {
  baseURL: 'https://api.auth.cerclex.com/',
};
